import { InvoiceStatusApiService } from '@api/api.service';
import { ReceiptStatusService } from '../base';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class InvoiceStatusService extends ReceiptStatusService {
  constructor(api: InvoiceStatusApiService) {
    super(api);
  }
}
